import { useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { autoRenewalBannerEnabled, unbindCardBannerEnabled } from 'reactApp/appHelpers/featuresHelpers/features/autoRenewalCommunication';
import { getActiveWebSubscription, getSubscriptionWithDisabledAutoRenewal } from 'reactApp/hooks/subscriptionCommunication.helpers';
import { useHasCardFlag } from 'reactApp/hooks/useHasCardFlag';
import { useSubscriptionCommunicationDataReady } from 'reactApp/hooks/useSubscriptionCommunicationDataReady';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { CardSelectors } from 'reactApp/modules/creditCard/creditCard.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useSubscriptionCommunicationBanners = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isMobile = useSelector(EnvironmentSelectors.isMobile);
    const { isLoaded: isCardLoaded } = useSelector(CardSelectors.getCard);
    const subscriptions = useSelector(BillingDataSelectors.getSubscriptionsList);

    const shouldLoadAutoRenewalCard = autoRenewalBannerEnabled && isPaidUser;
    const shouldLoadUnbindCard = unbindCardBannerEnabled && isPaidUser;
    const shouldLoadCard = shouldLoadAutoRenewalCard || shouldLoadUnbindCard;

    const isBillingDataReady = useSubscriptionCommunicationDataReady();
    const { hasCard, isLoaded: isHasCardFlagLoaded } = useHasCardFlag(shouldLoadCard);
    const isDataReady = isBillingDataReady && isHasCardFlagLoaded;

    const subscriptionWithDisabledAutoRenewal = getSubscriptionWithDisabledAutoRenewal(subscriptions);
    const activeWebSubscription = getActiveWebSubscription(subscriptions);
    const commonConditions = isDataReady && isPaidUser && !isBizUser && !isCorpUser && !IS_ONPREMISE && !isMobile;

    return {
        autoRenewalBanner: {
            shouldShowBanner: commonConditions && autoRenewalBannerEnabled && !!subscriptionWithDisabledAutoRenewal,
            subscription: subscriptionWithDisabledAutoRenewal,
            hasCard,
            isCardLoaded,
            shouldLoadCard: shouldLoadAutoRenewalCard,
            isDataReady,
        },
        unbindCardBanner: {
            shouldShowBanner: commonConditions && unbindCardBannerEnabled && !hasCard && !!activeWebSubscription,
            subscription: activeWebSubscription,
            shouldLoadCard: shouldLoadUnbindCard,
            isDataReady,
        },
    };
};
